import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useLocation } from '@reach/router';
import { loadStripe } from '@stripe/stripe-js';
import cx from 'classnames';
import NumberFormat from 'react-number-format';

const stripePromise = loadStripe(process.env.GATSBY_STRIPE_PUBLIC_KEY);

export const DonateForm = ({ title, listId, initialDonationAmount }) => {
  const [isLoading, setLoading] = React.useState(false);

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm();

  const { href } = useLocation();

  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const { sessionId } = await fetch('/.netlify/functions/create-donation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...data,
          returnUrl: href,
          donateCategory: title,
          anon: anon,
          preferredName: preferredName,
          listId: listId,
        }),
      }).then((res) => res.json());

      const stripe = await stripePromise;

      const { error } = await stripe.redirectToCheckout({
        sessionId,
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
      return Promise.reject(error);
    }
  };

  const [preferred, setPreferred] = React.useState(false);
  const [preferredName, setPreferredName] = React.useState('');
  const [anon, setAnon] = React.useState(false);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={cx({
        'cursor-wait': isLoading,
      })}>
      <input
        required
        placeholder='First Name*'
        className='styledInput'
        {...register('customerDetails.firstName', { required: true })}
      />
      <input
        required
        placeholder='Last Name*'
        className='styledInput'
        {...register('customerDetails.lastName', { required: true })}
      />
      <input
        placeholder='Company Name'
        className='styledInput'
        {...register('customerDetails.company', { required: false })}
      />
      <input
        required
        placeholder='Email Address*'
        className='styledInput'
        {...register('customerDetails.email', { required: true })}
      />
      <div>
        {errors.customerDetails?.phone && (
          <p className='errorMessage text-magenta '>
            {errors.customerDetails.phone.message}
          </p>
        )}
        <input
          required
          placeholder='Phone Number*'
          className='styledInput '
          {...register('customerDetails.phone', {
            required: true,
            pattern: {
              value: /^\+[1-9]\d{1,14}$/,
              message:
                'Please enter valid phone number with country code (e.g. +64 21123456)',
            },
          })}
        />
      </div>

      <div className='relative'>
        <Controller
          name='donationAmount'
          control={control}
          defaultValue={initialDonationAmount}
          rules={{ max: 1000000, required: true }}
          render={({ field: { onChange, onBlur, name, value, ref } }) => {
            return (
              <>
                <NumberFormat
                  allowNegative={false}
                  decimalScale={2}
                  fixedDecimalScale
                  onValueChange={(values) => onChange(values.floatValue)}
                  name={name}
                  value={value}
                  onBlur={onBlur}
                  ref={ref}
                  className='styledInput'
                  placeholder='Donation amount*'
                />
                {!!value && (
                  <span className='absolute -left-1 top-[7px] text-grey blockH8'>
                    $
                  </span>
                )}
              </>
            );
          }}
        />
      </div>

      <div className='opacity-50'>
        <span>Acknowledgement of my gift</span>
        <div className='flex flex-col gap-y-4 mt-4 blockH8'>
          <div className='flex gap-x-[10px] items-center'>
            <input
              type='radio'
              name='choice'
              id='anon'
              className='w-6 h-6 bg-sand'
              onChange={() => {
                setAnon(true);
                setPreferred(false);
                setPreferredName('');
              }}
            />
            <label htmlFor='anon'>Remain anonymous</label>
          </div>
          <div className='flex gap-x-[10px] items-center'>
            <div className='flex gap-x-[10px] items-center'>
              <input
                type='radio'
                name='choice'
                id='preferred'
                className='w-6 h-6 bg-sand'
                onChange={() => {
                  setAnon(false);
                  setPreferred(true);
                }}
              />
              <label htmlFor='preferred' className='block whitespace-nowrap'>
                Please acknowledge as
              </label>
            </div>
            <input
              type='text'
              className='h-6 bg-sand border-0 border-b w-full'
              value={preferredName}
              disabled={!preferred}
              onChange={(e) => setPreferredName(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className='flex flex-col md:flex-row gap-y-6 items-center justify-between mt-10'>
        {/* <span className='blockH9 opacity-50 block'>*<a className='underline' href="https://stripe.com/en-nz/pricing/local-payment-methods" target="_blank" rel="noreferrer">Stripe Checkout fee</a> applied automatically</span> */}
        <button
          type='submit'
          className='btn-standard bg-teal bg-opacity-10 text-teal flex'>
          Donate now
        </button>
      </div>
    </form>
  );
};
